import React from "react";

export const CloseIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg fill="currentColor" height="10" viewBox="0 0 10 10" width="10" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 1.007L8.993 0L5 3.993L1.007 0L0 1.007L3.993 5L0 8.993L1.007 10L5 6.007L8.993 10L10 8.993L6.007 5L10 1.007Z" />
  </svg>
);
